var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.59,23.51a6,6,0,0,0-6.27.41L71.88,36.08V26.71A8.72,8.72,0,0,0,63.17,18H10.33a8.72,8.72,0,0,0-8.71,8.71v46.7a8.72,8.72,0,0,0,8.71,8.71H63.17a8.72,8.72,0,0,0,8.71-8.71V63.24L89.16,76.08a6.07,6.07,0,0,0,6.35.57A6.4,6.4,0,0,0,99,70.89V29.22A6.4,6.4,0,0,0,95.59,23.51ZM66.47,73.41a3.31,3.31,0,0,1-3.3,3.31H10.33A3.31,3.31,0,0,1,7,73.41V26.71a3.31,3.31,0,0,1,3.31-3.31H63.17a3.31,3.31,0,0,1,3.3,3.31Zm27.17-2.52a1,1,0,0,1-.53,1,.69.69,0,0,1-.75-.07L72.64,57.13a1.11,1.11,0,0,1-.42-.89V43a1.12,1.12,0,0,1,.44-.91L92.38,28.31a.67.67,0,0,1,.74,0,1,1,0,0,1,.52,1Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraIcon);
export default __webpack_public_path__ + "static/media/video-camera-icon.2306a7ed468cb0a5b0cd9b08649a5fc0.svg";
export { ForwardRef as ReactComponent };